import React from 'react'
import styled, { keyframes } from 'styled-components'
import TrashIcon from '../../../../../generic/icons/IconLib/TrashIcon'

export interface OrderDeleteConfirmProps {
  onConfirm: () => void
  className?: string
}

const OrderDeleteConfirm: React.FC<OrderDeleteConfirmProps> = ({
  onConfirm,
  className,
}) => (
  <Btn
    type='button'
    onClick={onConfirm}
    aria-label='confirm delete'
    className={className}
  >
    <TrashIcon size={18} />
  </Btn>
)

export default OrderDeleteConfirm

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

const Btn = styled.button`
  flex-shrink: 0;
  align-self: stretch;
  width: 4.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: ${({ theme }) => theme.colors.danger};
  color: #ffffff;
  cursor: pointer;
  user-select: none;
  animation: ${fadeIn} 0.18s ease-out;
  transition:
    transform ${({ theme }) => theme.motion.fast} ease,
    filter ${({ theme }) => theme.motion.fast} ease;

  &:hover {
    filter: brightness(0.95);
  }

  &:active {
    transform: scale(0.97);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 3.5rem;
  }
`
